import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Hero, QuestionsMarquee } from "./components/site/Hero";
import { Lettre } from "./components/site/Lettre";
import { Priorites } from "./components/site/Priorites";
import { Dette } from "./components/site/Dette";
import { BandeDessinee } from "./components/site/BandeDessinee";
import { Histoires } from "./components/site/Histoires";
import { FranceAvenir } from "./components/site/FranceAvenir";
import { Regles } from "./components/site/Regles";
import { BusinessPlan } from "./components/site/BusinessPlan";
import { Documents } from "./components/site/Documents";
import { Notes } from "./components/site/Notes";
import { Chanson } from "./components/site/Chanson";
import { Signer } from "./components/site/Signer";
import { Footer } from "./components/site/Footer";
import { AccessGate } from "./components/site/AccessGate";
import { SectionTracker } from "./components/site/SectionTracker";
import StatsPage from "./components/site/StatsPage";
import axios from "axios";

axios.defaults.withCredentials = true;

function App() {
  if (window.location.pathname.replace(/\/+$/, "") === "/stats") {
    return <><StatsPage /><Toaster position="top-center" richColors /></>;
  }
  return (
    <AccessGate>
    <SectionTracker />
    <div className="mm-root bg-mm-paper text-mm-ink overflow-x-clip">
      <Header />
      <main>
        <Hero />
        <QuestionsMarquee />
        <Lettre />
        <Priorites />
        <FranceAvenir />
        <Dette />
        <BusinessPlan />
        <Regles />
        <BandeDessinee />
        <Histoires />
        <Chanson />
        <Notes />
        <Documents />
        <Signer />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
    </AccessGate>
  );
}

export default App;
